import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MultiselectObjectManagerComponentBase } from '../../../core/component/multiselect-object-manager/multiselect-object-manager.component';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { StandardCommandHandlerResolver } from '../../../core/service/command/standard-command-handler-resolver.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { IndexClauseSettings } from '../../model/index-clause-settings';
import { IndexClauseSettingsService } from '../../service/data/index-clause-settings.service';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';

@Component({
  selector: 'app-index-clause-settings-manager',
  templateUrl: './../../../core/component/multiselect-object-manager/multiselect-object-manager.template.html',
  styleUrls: ['./../../../core/component/multiselect-object-manager/multiselect-object-manager.component.scss'],
  providers: [StandardCommandHandlerResolver],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class IndexClauseSettingsManagerComponent extends MultiselectObjectManagerComponentBase<IndexClauseSettings> {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    dataService: IndexClauseSettingsService,
    dispatcher: CommandDispatcher,
    messageService: MessageService,
    navigationService: NavigationService,
    handlerResolver: StandardCommandHandlerResolver
  ) {
    super(dataService, dispatcher, handlerResolver, messageService, navigationService);
    this.columnDefinition = columnDefinitionService.create('IndexClauseSettings');
    this.title = 'INDEX_CLAUSE_SETTINGS.LIST_HEADER';
    this.preferencesKey = 'rent.index-clause-settings.list';
  }
}
